export default __webpack_public_path__ + "static/secretLab-83a08dfda436775f819a235d35782f0a.png";